export default __webpack_public_path__ + "static/threeds-60e6e637deaba11ac2617dd01e9145f7.png";